import memoize from 'memoizee';
import config from '@/constants/config';

const getCryptoPools = memoize(async () => {
    const hasCryptoPoolsEndpoint = !!config.cryptoPoolsEndpoint;
    if (!hasCryptoPoolsEndpoint) return [];

    const { data: { poolData } } = await (await fetch(config.cryptoPoolsEndpoint)).json();
    return poolData;
}, {
    promise: true,
    maxAge: 60 * 1000, // 1m
});

export default getCryptoPools;
